var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 17.891C12.2708 17.891 12.4906 17.6712 12.4906 17.4001C12.4906 17.129 12.2708 16.9092 11.9997 16.9092C11.7286 16.9092 11.5088 17.129 11.5088 17.4001C11.5088 17.6712 11.7286 17.891 11.9997 17.891Z",
    fill: "#848D27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 22.8002C17.9649 22.8002 22.8002 17.9649 22.8002 12.0002C22.8002 6.03552 17.9649 1.2002 12.0002 1.2002C6.03552 1.2002 1.2002 6.03552 1.2002 12.0002C1.2002 17.9649 6.03552 22.8002 12.0002 22.8002Z",
    stroke: "#848D27",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.10889V13.9634",
    stroke: "#848D27",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 17.891C12.2708 17.891 12.4906 17.6712 12.4906 17.4001C12.4906 17.129 12.2708 16.9092 11.9997 16.9092C11.7286 16.9092 11.5088 17.129 11.5088 17.4001C11.5088 17.6712 11.7286 17.891 11.9997 17.891Z",
    stroke: "#848D27",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation_circle.a822cf44dc57f4e5a7d295a70568313f.svg";
export { ForwardRef as ReactComponent };